import React, { ReactElement, useState } from 'react';
import styles from './passwordInput.module.scss';
import classnames from 'classnames';

interface PasswordProps {
    password: string;
    error: string | undefined;
    onChange: (password: string) => void;
}

const CurrentPasswordInput: React.FunctionComponent<PasswordProps> = ({ password, onChange, error }): ReactElement => {
    const [visibility, setVisibility] = useState<boolean>(false);

    const setPasswordVisibility = (newVisibility: boolean): void => {
        setVisibility(newVisibility);
    };

    return (
        <div>
            <label className={styles.inputLabel} htmlFor='currentPassword'>
                Current password
            </label>
            <div
                className={classnames(
                    { [styles.errorPasswordInputGroup]: error },
                    styles.passwordInputGroup,
                    styles.currentPasswordInputGroup
                )}
            >
                <ul className={styles.inlineErrors}>
                    {error && (
                        <li key={error} className={styles.inlineErrorMessage}>
                            {error}
                        </li>
                    )}
                </ul>

                <div className={styles.passwordInputField}>
                    <input
                        id='currentPassword'
                        className={classnames({ [styles.errorInputField]: error }, styles.inputField)}
                        aria-describedby={'password-input-hint-text password-requirements'}
                        type={visibility ? 'text' : 'password'}
                        value={password}
                        onChange={(event): void => onChange(event.target.value)}
                    />
                    <button
                        className={classnames({ [styles.errorButton]: error }, styles.showHideButton)}
                        onClick={(): void => setPasswordVisibility(!visibility)}
                        data-ga={!visibility ? 'show-password' : 'hide-password'}
                        aria-live={'polite'}
                        aria-label={
                            !visibility
                                ? 'By clicking on this button, text typed in the password field will be displayed and will be spoken by screen readers'
                                : undefined
                        }
                        type={'button'}
                    >
                        {visibility ? 'Hide password' : 'Show password'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CurrentPasswordInput;
